import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    connect() {
        this.element.querySelectorAll(`[data-push]`).forEach((link) => {
            link.addEventListener('click', () => {
                let push = link.getAttribute('data-push');
                if (push) {
                    history.pushState(null, '', push);
                }
            });
        })
    }
}